import React from 'react';
import { capImageSrc, capImageSrcSet } from '@/data/capPresentation';

export default function CapEditorialImage({ name, alt, priority = false, sizes = '100vw', ...props }) {
  return <img
    src={capImageSrc(name)}
    srcSet={capImageSrcSet(name)}
    sizes={sizes}
    width="1200"
    height="1200"
    alt={alt}
    loading={priority ? 'eager' : 'lazy'}
    fetchpriority={priority ? 'high' : undefined}
    decoding="async"
    {...props}
  />;
}
